interface DotPaginationProps {
    totalPages: number;
    currentPage: number;
    onPageChange: (page: number) => void;
}

const DotPagination = ({ totalPages, currentPage, onPageChange }: DotPaginationProps) => {
    return (
        <div className="flex items-center justify-center gap-2 mt-4 paginationdots-dv">
            {Array.from({ length: totalPages }, (_, index) => (
                <button
                    key={index}
                    onClick={() => onPageChange(index)}
                    className={`w-2 h-2 rounded-full transition-all ${
                        currentPage === index
                            ? 'bg-main-blue w-6 activepagination'
                            : 'bg-surface-border hover:bg-text-text-secondary'
                    }`}
                    aria-label={`Go to page ${index + 1}`}
                />
            ))}
        </div>
    );
};

export default DotPagination;
